"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Severity =
/*#__PURE__*/
function () {
  function Severity() {
    var _this = this;

    (0, _classCallCheck2.default)(this, Severity);
    var severities = {
      CRITSIT: {
        id: 0,
        priority: 4
      },
      OUTAGE: {
        id: 1,
        priority: 3
      },
      MAINTENANCE: {
        id: 2,
        priority: 2
      },
      DEBUG: {
        id: 3,
        priority: 1
      }
    };
    this.idIndex = {};
    Object.keys(severities).forEach(function (key) {
      var value = severities[key];
      _this[key] = value;
      value.key = key;
      _this.idIndex[value.id] = value;
    });
  }

  (0, _createClass2.default)(Severity, [{
    key: "getById",
    value: function getById(id) {
      return this.idIndex[id];
    }
  }, {
    key: "getByKey",
    value: function getByKey(key) {
      return this[key];
    }
  }]);
  return Severity;
}();

var _default = new Severity();

exports.default = _default;
module.exports = exports.default;